import { render, staticRenderFns } from "@/style-guide/partials/item-thumb/item-thumb.pug?vue&type=template&id=6eaa251a&lang=pug&external"
import script from "./item-thumb.vue?vue&type=script&lang=ts"
export * from "./item-thumb.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports